import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "sonner";
import { useLenis } from "./components/site/useLenis";
import Home from "./pages/Home";
import LegalPage from "./pages/LegalPage";
import { Intro } from "./components/site/Intro";

function App() {
  useLenis();
  return (
    <MotionConfig reducedMotion="user">
      <div className="min-h-screen bg-[#FBF9F4] font-body text-[#1B281E]">
        <Intro />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<LegalPage page="impressum" />} />
            <Route path="/datenschutz" element={<LegalPage page="datenschutz" />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </MotionConfig>
  );
}

export default App;
